import React, { Component } from 'react';
import { array, func, string } from 'prop-types';
import AdvancedTable, { formatSubHeader } from '../../../AdvancedTable/AdvancedTable';
import ReportTableRow from './JobRangesTableRow';

import './JobRangesTable.scss';

const CREATED_ON = 'Created on',
  RANGE_TYPE = 'Range Type',
  NUMBER_OF_JOBS = 'Jobs',
  NUMBER_OF_EMPLOYEES = 'Employees',
  COST_BELOW_MIN = 'Cost to Min',
  COST_ABOVE_MAX = 'Amount Above Max',
  EES_BELOW_MIN = 'EEs Below Min',
  EES_ABOVE_MAX = 'EEs Above Max',
  CURRENT_AS_OF = 'Current as of',
  DELETE = 'Delete',
  LABEL = 'Label',
  NAME = 'Name',
  AVG_COMPA_RATIO = 'Avg Compa Ratio',
  AVG_RANGE_PEN = 'Avg Position in Range';

class JobRangesTable extends Component {
  static propTypes = {
    deleteModel: func,
    jobRangeModels: array
  };

  constructor(props) {
    super(props);
    this.getTableRow = this.getTableRow.bind(this);
  }

  getTableRow(jobRangeModel) {
    const { deleteModel, jobRangeModels, preferences } = this.props;
    return (
      <ReportTableRow deleteModel={deleteModel} key={jobRangeModel.id} preferences={preferences} {...jobRangeModel} />
    );
  }

  render() {
    const { deleteModel, jobRangeModels } = this.props;
    const columnHeaders = [
      {
        Header: NAME,
        width: 170,
        accessor: 'name'
      },
      {
        Header: RANGE_TYPE,
        width: 90,
        accessor: 'rangeType'
      },
      {
        Header: NUMBER_OF_JOBS,
        width: 60,
        accessor: 'jobCount',
        centerAlign: true
      },
      {
        Header: NUMBER_OF_EMPLOYEES,
        width: 90,
        accessor: 'employeeCount',
        centerAlign: true
      },
      {
        Header: formatSubHeader,
        HeaderText: EES_BELOW_MIN,
        SubHeaderText: 'Current/Proposed',
        id: 'eesBelowMin',
        width: 100,
        centerAlign: true
      },
      {
        Header: formatSubHeader,
        HeaderText: EES_ABOVE_MAX,
        SubHeaderText: 'Current/Proposed',
        id: 'eesAboveMax',
        width: 100,
        centerAlign: true
      },
      {
        Header: formatSubHeader,
        HeaderText: COST_BELOW_MIN,
        SubHeaderText: 'Current/Proposed',
        id: 'costBelowMin',
        width: 100,
        centerAlign: true
      },
      {
        Header: formatSubHeader,
        HeaderText: COST_ABOVE_MAX,
        SubHeaderText: 'Current/Proposed',
        id: 'costAboveMax',
        width: 120,
        centerAlign: true
      },
      {
        Header: formatSubHeader,
        HeaderText: AVG_COMPA_RATIO,
        SubHeaderText: 'Current/Proposed',
        id: 'compaRatio',
        width: 110,
        centerAlign: true
      },
      {
        Header: formatSubHeader,
        HeaderText: AVG_RANGE_PEN,
        SubHeaderText: 'Current/Proposed',
        id: 'rangePen',
        width: 130,
        centerAlign: true
      },
      {
        Header: CURRENT_AS_OF,
        width: 140
      },
      {
        Header: CREATED_ON,
        width: 140,
        accessor: 'created'
      },
      {
        Header: DELETE,
        width: 50
      }
    ];

    return (
      <div className="jbr-model__table-container">
        <AdvancedTable
          allowSorting={true}
          staticTable={false}
          isBasic={true}
          stickyHeader
          columnHeaders={columnHeaders}
          rowData={jobRangeModels}
          getDataRow={this.getTableRow}
          className="jbr-model__table"
          headerClassName="jbr-model__table-header"
          initialSortBy={[{ desc: true, id: 'created' }]}
        />
      </div>
    );
  }
}

export default JobRangesTable;
